module.exports = __webpack_public_path__ + "static/img/brees-2007-slide-5.7870026.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brees-2007-slide-5.jpg
// module id = 81nA
// module chunks = 1